export default ["😐", "😶", "🤑", "😎", "😘", "🤩"];



// WEBPACK FOOTER //
// ./src/data/emoji.js